<div class="h-full">
  <div class="w-full relative">
    @if (isLoading()) {
      <div class="w-full absolute">
        <mat-progress-bar
          class="mds-x-small"
          data-cy="classification-loader"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      </div>
    }
  </div>

  <div class="h-full flex flex-1 flex-col p-4 bg-white border border-gray-0 rounded">
    <!-- error alert -->
    @if (hasError()) {
      <div class="w-full mb-4">
        <modus-alert
          class="w-full"
          message="{{ errorMessage() }}"
          type="error"
          dismissible
          (dismissClick)="dismissAlert()"
        ></modus-alert>
      </div>
    }

    <div class="flex flex-1 flex-row justify-end mb-2">
      <!-- save options -->
      @if (state.dirty()) {
        <span>
          <button modus-button (click)="cancel()" [disabled]="isLoading()">
            {{ translations.cancel.text }}
          </button>
          <button
            modus-flat-button
            color="primary"
            class="ml-1"
            (click)="save()"
            [disabled]="disableSave()"
          >
            {{ translations.save.text }}
          </button>
        </span>
      } @else {
        <!-- reset -->
        <button
          modus-button
          data-cy="reset-classifications-button"
          (click)="reset()"
          [disabled]="isLoading()"
        >
          {{ translations.reset.text }}
        </button>

        <!-- export -->
        <button
          modus-flat-button
          color="secondary"
          class="mx-4"
          data-cy="export-classification-button"
          (click)="export()"
          [disabled]="isLoading()"
        >
          {{ translations.export.text }}
        </button>

        <!-- import -->
        <input
          #fileImportInput
          type="file"
          accept="application/json"
          data-cy="import-classification-input"
          (change)="onFileSelected($event)"
          style="display: none"
        />
        <button
          modus-flat-button
          color="primary"
          (click)="fileImportInput.click()"
          [disabled]="isLoading()"
        >
          {{ translations.import.text }}
        </button>
      }
    </div>

    <div class="h-full overflow-y-scroll">
      <sd-config-classification-table
        #classificationTable
        [classifications]="classifications()"
        [disabled]="isLoading()"
      ></sd-config-classification-table>
    </div>
  </div>
</div>
